import React, { Fragment, useEffect, useState } from "react";

import { AntInput } from "../../antinput";
import { CallPopUpAgentActions } from "../../../../store/slices/voice_call_slice/call_popup_agent";
import { CallService } from "../../../../services/call_service";
import { ChatState } from "../../../../base/models/model";
import { CallServices, CoreServices } from "../../../../base/service/apiServices";
import callChatService from "../../../../base/service/chatService";
import { CallSDK } from "unifiedring-sdk";
import styles from "./tabQueueTransfer.module.scss";
import { useDispatcher } from "../../../../custom_hooks/use_app_dispatch";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import { getQueueeList, searchQueueList } from "../../../../store/api/helperspi/contactListapiService";
import store from "../../../../store/redux-store/root_store";
import { dispositionSliceActions } from "../../../../store/slices/dispositionSlice/postDisposition";

let { CallHold } = CallSDK.Call;
function TabQueueTransfer() {
  const [queueList, setQueueList] = useState<any>([]);
  const callDetails: any = useSelector((state: any) => state.callPopUpDetails.callDetails);
  const popUpDetails: any = useSelector((state: any) => state.callPopUpDetails);
  // const popUpDetails: any = store.getState().callPopUpDetails;
  const chatReducer: ChatState = useSelector((state: any) => state.chatReducer);
  const dispatch = useDispatcher();
  const navigate = useNavigate();
  const QueueListDetails: any = useSelector((state: any) => state.contactListForAgent);
  const { AllQueueList } = QueueListDetails;
  const { dialPadChanges } = CallService(dispatch, navigate);
  const { dispositionTagList } = useSelector((state: any) => state.contactListForAgent);

  const getQueueList = (e: any) => {
    if (e?.target?.value?.trim() !== "") {
      const filterqueue = AllQueueList.filter((Queue: { name: any }) => Queue.name.toLowerCase().includes((e?.target?.value?.trim().toLowerCase())))
      setQueueList(filterqueue);
    } else {
      setQueueList(AllQueueList);
    }
  };
  useEffect(() => {
    dispatch(getQueueeList());
  }, [dispatch]);


  useEffect(() => {
    setQueueList(AllQueueList);
  }, [AllQueueList])
  
  const makeCall = async (qid: any) => {
    const roomData: any = store.getState().chatReducer;
    dispatch(CallPopUpAgentActions.updateTransferType({ transfer_type: "QUEUE" }));
    let transferdata: any = {
      session_id: roomData?.currentSession?.sessionId,
      req_type: "AGENT_TRANSFER",
      transfer_type: 3,
      qid: `${qid}`
    };
    let data = {
      callHistoryId: roomData?.currentSession?.CallHistoryId,
      queueId: qid
    }
    // CallServices.post(data,'/queue_details')
    // .then((res:any)=>{
    //   console.log('res=========>',res)
    //   if(res.data.statusCode === 200){
    //     setTimeout(()=>{
    //       callChatService.transfer(transferdata);
    //     },10000)
    //   }
    // })
   const dis = dispositionTagList?.find((i: { dispositionName: any; }) => i.dispositionName === 'Transferred')
   dispatch(dispositionSliceActions.setDisposition({ key: dis }));
    callChatService.transfer(transferdata);
    dialPadChanges(false, false, false, false, false, false);
    // await makeCallFunctionForAll(qid, 3);
    // await makeCallForTransferToQueue(qid, 3);

    // // store.dispatch({
    // //   type: Types.TRANSFER_TYPE,
    // //   payload: {
    // //     transfer_type: "QUEUE",
    // //   },
    // // });
    // const token: any = Cookie.get();
    // let LoginUserDetails: any = JSON.parse(token["userDetials"]);
    // let data: any = {
    //   callStatus: "Dialing",
    //   to: LoginUserDetails.ext.toString(),
    //   bound: "OUT",
    //   from: qid,
    //   callType: "direct",
    //   isCurrent: true,
    //   guid: uuidv4(),
    // };
    // if (popUpDetails.isTransfer) {
    //   let transferdata: any = {
    //     session_id: chatReducer?.currentSession?.sessionId,
    //     req_type: "AGENT_TRANSFER",
    //     transfer_type: 3, //1 - Agent 2 - PSTN 3-Queue
    //     ddi: parseInt(qid),
    //   };
    //   callDetails.map((item: any) => {
    //     CallHold(item.useragent);
    //   });
    //   callDetails.map((item: any) => {
    //     item.isCurrent = false;
    //     item.holdState = true;
    //     return item;
    //   });
    //   setTimeout(() => {
    //     callDetails.push(data);
    //     makeTransferReduxSet(callDetails, data);
    //     callChatService.transfer(transferdata);
    //     CallTransferFunction(qid);
    //   }, 500);
    // } else {
    //   //callDetails.push(data)
    //   makeCallReduxSet(data);
    //   makeCallFunction(qid);
    // }
  };

  return (
    <>
      <div className={`${styles.callcontainartopsec}`}>
        <AntInput className="transferSearch searchbordered" onChange={getQueueList} placeHolder="Search" />
        <div className={styles.agentsList}>
          {queueList.length === 0
            ? "No data"
            : queueList.map((data: any, idx: any) => {
              return (
                <Fragment key={idx}>
                  {data?.status === 1 ? (
                    <div className={`${styles.users}`} onClick={() => makeCall(data.qid)}>
                      <div className={styles.callStatus}>
                        <div className={styles.ready}></div>
                      </div>
                      <div className={styles.userDetails}>
                        <span className={styles.agentName}>{data?.name}</span>
                      </div>
                    </div>
                  ) : (
                    <></>
                    // <div className={`${styles.users} ${styles.onHold}`}>
                    //   <div className={styles.callStatus}>
                    //     <div className={styles.offLine}></div>
                    //   </div>
                    //   <div className={styles.userDetails}>
                    //     <span className={styles.agentName}>{data?.name}</span>
                    //   </div>
                    // </div>
                  )}
                </Fragment>
              );
            })}
        </div>
      </div>
    </>
  );
}

export default TabQueueTransfer;
